
import ApiRequest from '../../api-request'
import { ICompany } from 'app/models/company'
import { ICreateCompanyInput } from './create-company/create-company-input'
import { IUpdateCompanyInput } from './update-company/update-company-input'

export const CompanyRepository = {
    getCompany: (communityId: string, companyId: string) => ApiRequest<null, ICompany>({
        method: 'GET',
        path: `/communities/${communityId}/companies/${companyId}`,
        responseType: 'json',
    }),
    getCompanies: (communityId: string) => ApiRequest<null, ICompany[]>({
        method: 'GET',
        path: `/communities/${communityId}/companies`,
        responseType: 'json',
    }),
    createCompany: async (communityId: string, input: ICreateCompanyInput) => ApiRequest<ICreateCompanyInput, null>({
        method: 'PUT',
        path: `/communities/${communityId}/companies`,
        responseType: 'json',
        data: input,
    }),
    updateCompany: async (communityId: string, companyId: string, input: IUpdateCompanyInput) => ApiRequest<IUpdateCompanyInput, null>({
        method: 'POST',
        path: `/communities/${communityId}/companies/${companyId}`,
        responseType: 'json',
        data: input,
    }),
    deleteCompany: async (communityId: string, companyId: string) => ApiRequest<null, null>({
        method: 'DELETE',
        path: `/communities/${communityId}/companies/${companyId}`,
        responseType: 'json',
    }),
}
